import styled from '../../../../styles/theme';
import { ModalCarOptionDetailStyled } from '../ModalCarOptionDetailStyled';
import { rem } from 'polished';

export const ModalCarOptionDetailStyledAC = styled(ModalCarOptionDetailStyled)``;
